/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-05-18 09:56:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-20 11:52:35
 */

import { requestOfPost, requestOfGet } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/member'

// 获取会员卡二维码
export function getMemberCardCode(param) {
  return requestOfPost(`${baseUrl}/dynamicqrcode`, param)
}
export function validMiniMember(param) {
  return requestOfPost(`${baseUrl}/checksmscode`, param)
}
export function saveUserProfile(param) {
  return requestOfPost(`${baseUrl}/profile/save`, param)
}
export function registerMiniMember(param) {
  return requestOfPost(`${baseUrl}/register`, param)
}
export function getMiniMemberInfo(param) {
  return requestOfGet(`${baseUrl}/profile/find?query.MobilePhone=${param.phone}&query.VpnId=${param.vpnId}`)
}
export function checkIsMiniMember(param) {
  return requestOfGet(`${baseUrl}/ismicromember/${param}`)
}
export function getEleCardTypeList(param) {
  return requestOfGet(`${baseUrl}/cardtype/list`,param)
}
export function getEleCardInfo(param) {
  return requestOfGet(`${baseUrl}/cardtype/${param.id}`,param)
}
export function getUserCardInfo(param) {
  return requestOfGet(`${baseUrl}/profile`,param)
}
export function getRechargePayMoney(param) {
  return requestOfPost(`${baseUrl}/recharge/settle`,param)
}
export function submitPayEleCard(param) {
  return requestOfPost(`${baseUrl}/recharge`,param)
}
export function getWetWechatCustomPage(param) {
  return requestOfGet(`wechath5/zh-cn/v1/page_layout`,param)
}
export function getWechatMemberCardDetail(param) {
  return requestOfGet(`${baseUrl}/detail`,param)
}
export function checkIsNeedRegisterWechatMember(param) {
  return requestOfGet(`${baseUrl}/check/${param.VpnId}/${param.SceneId}`)
}
export function getcouponScan(param) {
  return requestOfPost(`${baseUrl}/coupon/scan`,param)
}
export function getMemberCardList(param) { //获取我的会员卡
   return requestOfGet(`${baseUrl}/list`,param)
}
